const MS = {
    "loginTitle": "Log Masuk",
    "mobileNumLabel": "Nombor Telefon",
    "passwordLabel": "Kata Laluan",
    "loginButton": "Log Masuk",
    "forgotPasswordLink": "Terlupa Kata Laluan?",
    "forgotPassword": "Lupa Kata Laluan",
    "forgotPasswordButton": "Tetapkan Semula Kata Laluan",
    "signupPrompt": "Bukan ahli lagi?",
    "navHome": "Rumah",
    "navLocation": "Lokasi",
    "navProfile": "Profil",
    "navInstaller": "Pemasang",
    "navAbout": "Tentang",
    "verificationCodeLabel": "Kod Pengesahan (SMS)",
    "nameLabel": "Nama atau Nama Syarikat",
    "icNumLabel": "Nombor IC",
    "emailLabel": "Alamat Emel",
    "retypePasswordLabel": "Sahkan Kata Laluan",
    "termsText": "*Saya bersetuju dengan <a href='#'>syarat dan terma</a>",
    "signupButton": "Daftar",
    "mobileNumPlaceholder": "Masukkan nombor telefon",
    "verificationCodePlaceholder": "Masukkan kod pengesahan",
    "namePlaceholder": "Masukkan nama atau nama syarikat",
    "icNumPlaceholder": "Masukkan nombor IC",
    "emailPlaceholder": "Masukkan alamat emel",
    "otpButton": "Minta OTP",
    "faq1": "1. Bagaimana untuk mendaftarkan syarikat saya sebagai Pemasang?",
    "faq11": "Tekan 'Pemasang' di penjuru kanan bawah dan pilih 'Mohon'. Selepas anda memohon sebagai Pemasang, sila maklumkan kepada kami untuk disenaraikan dalam kategori Pemasang.",
    "faq2": "2. Apakah kegunaan Pemasang?",
    "faq22": "Bahagian pemasang adalah untuk membantu pengguna kami mencari pemasang yang sesuai untuk melengkapkan pemasangan lampu dan kelengkapannya.",
    "faq3": "3. Bagaimana untuk Menilai Pemasang?",
    "faq33": "Pergi ke 'Pemasang' (bar tab bawah) dan pilih pemasang yang anda minta sebelum ini, pilih 'Nilai & Ulas' untuk memberi komen dan menilai. Pilihan ini hanya boleh digunakan selepas membuat pembelian daripada AK Lighting.",
    "faq4": "4. Bolehkah saya menggunakan pemasang saya sendiri?",
    "faq44": "Ya, boleh. Sila ambil perhatian bahawa mana-mana pemasang yang tidak berdaftar dalam aplikasi kami tidak akan dapat dinilai dan diulas dalam platform aplikasi kami.",
    "faq5": "5. Apakah itu Inbox?",
    "faq55": "Apabila terdapat promosi, anda akan dimaklumkan secara automatik. Mesej yang diterima akan dihantar ke Inbox. Hidupkan pemberitahuan aplikasi supaya anda tidak terlepas tempoh promosi.",
    "faq6": "6. Di mana saya boleh mencari resit saya?",
    "faq66": "Pergi ke 'Profil', bahagian kanan atas 'Sejarah Pembelian' untuk menyemak pembelian anda.",
    "faq7": "7. Di mana saya boleh menyemak jumlah mata saya?",
    "faq77": "Pergi ke 'Profil', anda akan melihat mata anda bersama dengan Nama, No IC, dan No Telefon. Anda juga boleh mengedit gambar profil anda dengan mengetik 'Edit Foto'.",
    "faq8": "8. Apakah itu mata?",
    "faq88": "Sebanyak 500 mata akan dikreditkan kepada anda serta-merta apabila anda mendaftar sebagai ahli AK Lighting. Mata tambahan akan diperoleh dengan setiap pembelian.",
    "notificationText": "Notifikasi",
    "helplineText": "Talian Bantuan",
    "productsText": "Produk",
    "aboutusText": "Tentang Kami",
    "faqText": "Soalan Lazim",
    "languageText": "Bahasa",
    "facebookText": "Facebook",
    "logoutText": "Keluar",
    "about1": "A.K. Lighting adalah sebuah syarikat subsidiari yang diasaskan oleh JUSTlight. Seperti yang kita semua tahu, premis pameran JUSTlight kurang sesuai untuk promosi pelupusan stok kerana kekurangan tempat letak kereta.",
    "about2": "Oleh itu, kami telah menubuhkan syarikat baru, A.K. Lighting. Di Canaan Square, terdapat banyak tempat letak kereta yang percuma. Anda juga boleh terus mengakses ke bilik pameran kami. Kami percaya ini akan menjadi lebih mudah untuk pelanggan-pelanggan kami yang dihargai.",
    "about3": "Stok pelupusan kami terdiri daripada barangan berharga. Disebabkan harga LED yang semakin menyusut kini, dan kami masih mempunyai banyak stok lama, kami mengadakan pelupusan stok lama ini supaya dapat membawa masuk lebih banyak produk baru. Di sini, anda boleh mendapatkan lampu murah dan mampu milik.",
    "about4": "Kami juga membeli barangan berjenama seperti Philips dalam jumlah yang besar supaya dapat melakukan jualan pukal untuk manfaat pengguna. Di sini, anda boleh menemui pelbagai jenis lampu untuk apartmen, rumah kos rendah, Airbnb, dan sebagainya. Selain itu, kami juga menyediakan pelbagai aksesori untuk memudahkan ubah suai lampu dan aksesori untuk kegunaan kontraktor. Kami akan membawa masuk lebih banyak aksesori pada masa hadapan untuk kemudahan anda.",
    "about5": "Untuk aplikasi kami sendiri, kami membolehkan pengguna mendapatkan kemas kini terkini tentang promosi kami. Kami juga menyediakan senarai kontak kontraktor yang boleh anda lantik untuk pemasangan lampu. A.K. Lighting membawa penyelesaian pencahayaan ke kehidupan.",
    "installerTitle": "Pemasang",
    "applyButton": "Mohon",
    "detailsButton": "Maklumat Lanjut",
    "reviewButton": "Beri Penilaian",
    "mapLink": "Lihat Peta",
    "addressText": "Alamat:",
    "openHours": "Waktu Operasi:",
    "dateText": "Isnin hingga Ahad 8:30 pagi - 5:30 petang",
    "contactText": "Hubungi:",
    "installerApply": "Permohonan Pemasang",
    "applyTitle": "Borang Pemasang",
    "companyLabel": "Nama Syarikat",
    "contactLabel": "Hubungi",
    "contactPlaceholder": "Masukkan nombor hubungi",
    "genderLabel": "Jantina",
    "genderChoice": "Pilih jantina",
    "maleOption": "Lelaki",
    "femaleOption": "Perempuan",
    "raceLabel": "Bangsa",
    "racePlaceholder": "Masukkan bangsa",
    "experienceLabel": "Tahun Pengalaman",
    "experiencePlaceholder": "Masukkan tahun pengalaman",
    "workerLabel": "Bil. Pekerja",
    "workerPlaceholder": "Masukkan bilangan pekerja",
    "specialtyLabel": "Kepakaran",
    "specialty1": "Lampu",
    "specialty2": "Pendawaian",
    "specialty3": "Kipas",
    "specialty4": "Projek",
    "otherLabel": "Lain-lain",
    "otherPlaceholder": "Masukkan kepakaran lain",
    "addressLabel": "Alamat",
    "addressPlaceholder": "Masukkan alamat",
    "submitButton": "Hantar",
    "invoiceLabel": "No. invois untuk menilai & komen",
    "invoiceSelect": "Pilih No. Invois",
    "ratingLabel": "Penilaian",
    "commentLabel": "Komen",
    "commentPlaceholder": "Masukkan Komen",
    "uploadLabel": "Muat Naik Foto",
    "closeButton": "Tutup",
    "profileTitle": "Profil",
    "mobileUpdate": "Kemaskini Telefon",
    "passwordUpdate": "Kemaskini Kata Laluan",
    "referralList": "Senarai Rujukan",
    "deleteAccount": "Tutup Akaun",
    "deleteButton": "Tutup Akaun",
    "deleteText": "Padamkan akaun anda secara kekal",
    "deleteTitle": "Sahkan penutupan akaun?",
    "postDeletion": "Kami akan menghubungi nombor telefon anda dan meminta beberapa butiran untuk memadamkan akaun. Setelah segala sesuatu disahkan, akaun akan dimasukkan ke dalam senarai untuk dipadamkan dalam masa 30 hari.",
    "cancelDelete": "Batal",
    "confirmDelete": "Sahkan",
    "purchaseHistory": "Sejarah Pembelian",
    "editButton": "Edit",
    "editPhoto": "Edit Foto",
    "memberName": "Nama:",
    "memberIc": "Nombor IC:",
    "memberMobile": "Nombor Telefon:",
    "pointLabel": "Jumlah Mata",
    "memberLabel": "Ahli Sejak",
    "Are you sure you wnat to logout?": "Adakah anda pasti mahu log keluar?",
    "About Menu": "Tentang Menu",
    "OTP must be 6 digits": "OTP mesti 6 digit",
    "Password and Confirm Password not match": "Kata laluan dan Pengesahan Kata Laluan tidak sepadan",
    "Invalid Login Credential": "Maklumat log masuk tidak sah",
    "no_internet": "Masalah sambungan pelayan",
    "Login successfully!": "Log masuk berjaya!",
    "Please Check terms and condition": "Sila semak terma dan syarat",
    "OTP not Valid": "OTP tidak sah",
    "termsText1": "*Saya bersetuju dengan",
    "termsText2": "terma dan syarat",
    "Promotion": "Promosi",
    "Category": "Kategori",
    "Ratings": "Penilaian",
    "ContactNoTitle": "No. Telefon",
    "Overall Rating": "Penilaian Keseluruhan",
    "(no rating)": "(tiada penilaian)",
    "Overall Rating (no rating)": "Penilaian Keseluruhan (tiada penilaian)",
    "AK Lighting (Canaan Square Stutong)": "AK Lighting (Canaan Square Stutong)",
    "addressText1": "No. C2-G-4 Blok C, Lobi 2, Tingkat Bawah, Unit 4, Canaan Square, Q403A, 93350 Kuching, Sarawak",
    "AK Lighting (Matang Metrocity)": "AK Lighting (Matang Metrocity)",
    "addressText2": "Tingkat Bawah, S/L 22&23, Lot Tinjauan 13768 Sek. 65, KTLD, Metrocity, Jalan Matang, Jalan Matang, 93050 Kuching, Sarawak",
    "Description:": "Penerangan:",
    "Old Password Required": "Kata Laluan Lama Diperlukan",
    "Password Required": "Kata Laluan Diperlukan",
    "Confirm Password Required": "Pengesahan Kata Laluan Diperlukan",
    "New Password": "Kata Laluan Baru",
    "Confirm Password": "Sahkan Kata Laluan",
    "Copy Incoive ID": "Salin ID Invois",
    "Invoice No:": "No. Invois:",
    "Subtotal:": "Jumlah Kecil:",
    "Discount:": "Diskaun:",
    "Tax:": "Cukai:",
    "View": "Lihat",
    "Invoice": "Invois",
    "Id": "ID",
    "Name": "Nama",
    "Price": "Harga",
    "QTY": "Kuantiti",
    "Total": "Jumlah",
    "Grand Total:": "Jumlah Keseluruhan:",
    "otherOption": "Lain-lain",
    "Announcement": "Pengumuman",
    "Load More": "Muatkan Lagi",
    "No more data to load": "Tiada lagi data untuk dimuatkan",
    "Data not found!": "Data tidak dijumpai!",
    "PointsHistory": "Sejarah Mata",
    "Next_link_not_found": "Pautan seterusnya tidak dijumpai!"
};
export default MS;